import {makeShapeTemplate} from 'rlink-collections';
import {objectOf, arrayOf, instanceOf, shape, string, bool, number, node} from 'rlink-shapes';


const ROUTING_STATE_SHAPE = makeShapeTemplate(
  shape({
    current: shape({
      view: string,
      params: objectOf(string).isRequired,
      transition: string,
      mountedContent: node,
      scrollPosition: shape({top: number, left: number}),
    }),
    nextTransition: string,
    defaultLocale: string,
    defaultRegion: string,
    useLongCaches: bool,
    useLiveSafetyFeatures: bool,
    modals: arrayOf(node),
    flyouts: objectOf(node).isRequired,
    messages: objectOf(objectOf(string).isRequired).isRequired,
    contentMetaIndex: shape({
      translated: objectOf(string).isRequired,
      untranslated: objectOf(objectOf(string).isRequired).isRequired,
    }),
    routeDefinitions: shape({
      routes: objectOf(shape({
        view: string,
        params: objectOf(string).isRequired,
        choices: objectOf(string).isRequired,
      })).isRequired,
      choices: objectOf(arrayOf(string)).isRequired,
    }),
    routePatterns: arrayOf(shape({
      reRoute: instanceOf(RegExp),
      paramNameToGroupNum: objectOf(number).isRequired,
      view: string,
    })),
    routesByView: objectOf(objectOf(arrayOf(shape({
      routePattern: string,
      paramKeys: arrayOf(string),
    }))).isRequired).isRequired,
  })
);

export default ROUTING_STATE_SHAPE;



// WEBPACK FOOTER //
// ./lib/rlink-router/ROUTING_STATE_SHAPE.js